export const SET_CONFIG = 'SET_CONFIG';
export const RESET_CONFIG = 'RESET_CONFIG';
export const SET_LOCAL_SETTINGS = 'SET_LOCAL_SETTINGS';
export const SET_REMOTE_SETTINGS = 'SET_REMOTE_SETTINGS';
